const headers = {
  name: "Bank Reconcilliation",
  navigate: {
    tabs: [
      {
        name: "Bank Reconcilliation",
        path: "/app/bank-reconciliation",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
